module.exports = __webpack_public_path__ + "static/media/icon.8f2575f2.svg";